"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeSelector = void 0;
var R = __importStar(require("../../utils/ramda"));
var TriStateCheckbox_1 = require("../../components/TriStateCheckbox");
var TreeSelector = /** @class */function () {
  function TreeSelector(_a) {
    var _b = _a.rootId,
      rootId = _b === void 0 ? function () {
        return "root";
      } : _b,
      _c = _a.name,
      name = _c === void 0 ? function (nodeId) {
        return nodeId.toString();
      } : _c,
      parent = _a.parent,
      info = _a.info,
      children = _a.children,
      isNotParent = _a.isNotParent,
      all = _a.all;
    var _this = this;
    this.rootId = rootId;
    var parentBackup = function (id, context) {
      return id === _this.rootId(context) ? undefined : _this.rootId(context);
    };
    this.parent = function (id, context) {
      var _a;
      return (_a = parent(id, context)) !== null && _a !== void 0 ? _a : parentBackup(id, context);
    };
    this.children = function (id, context) {
      var _a;
      return (_a = children(id, context)) !== null && _a !== void 0 ? _a : [];
    };
    this.info = info !== null && info !== void 0 ? info : function () {
      return undefined;
    };
    this.isNotParent = isNotParent !== null && isNotParent !== void 0 ? isNotParent : function (nodeId, context) {
      return _this.children(nodeId, context).length === 0;
    };
    this.name = name;
    this.all = all !== null && all !== void 0 ? all : function (pred, context) {
      return _this._all(pred, _this.rootId(context), context);
    };
  }
  TreeSelector.prototype._all = function (predicate, nodeId, context) {
    var _a, _b, child, e_1_1;
    var e_1, _c;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          if (!predicate(nodeId)) return [3 /*break*/, 2];
          return [4 /*yield*/, nodeId];
        case 1:
          _d.sent();
          _d.label = 2;
        case 2:
          _d.trys.push([2, 7, 8, 9]);
          _a = __values(this.children(nodeId, context)), _b = _a.next();
          _d.label = 3;
        case 3:
          if (!!_b.done) return [3 /*break*/, 6];
          child = _b.value;
          return [5 /*yield**/, __values(this._all(predicate, child, context))];
        case 4:
          _d.sent();
          _d.label = 5;
        case 5:
          _b = _a.next();
          return [3 /*break*/, 3];
        case 6:
          return [3 /*break*/, 9];
        case 7:
          e_1_1 = _d.sent();
          e_1 = {
            error: e_1_1
          };
          return [3 /*break*/, 9];
        case 8:
          try {
            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
          } finally {
            if (e_1) throw e_1.error;
          }
          return [7 /*endfinally*/];
        case 9:
          return [2 /*return*/];
      }
    });
  };

  TreeSelector.prototype.createMap = function (fn) {
    var e_2, _a;
    var map = {};
    try {
      for (var _b = __values(this._all(R.T, this.rootId(), {})), _c = _b.next(); !_c.done; _c = _b.next()) {
        var nodeId = _c.value;
        map[nodeId] = fn(nodeId);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return map;
  };
  TreeSelector.prototype.emptyExpansion = function () {
    return this.createMap(function (_) {
      return false;
    });
  };
  TreeSelector.prototype.fullExpansion = function () {
    return this.createMap(function (_) {
      return true;
    });
  };
  TreeSelector.prototype.listExpansion = function (nodeIds, initialExpansions) {
    return nodeIds.reduce(function (p, c) {
      return R.assoc(c.toString(), true, p);
    }, initialExpansions !== null && initialExpansions !== void 0 ? initialExpansions : this.emptyExpansion());
  };
  TreeSelector.prototype.emptySelection = function () {
    return this.createMap(function (_) {
      return TriStateCheckbox_1.TriState.Empty;
    });
  };
  TreeSelector.prototype.fullSelection = function () {
    return this.createMap(function (_) {
      return TriStateCheckbox_1.TriState.Full;
    });
  };
  TreeSelector.prototype.listSelection = function (nodeIds, initialSelection, state) {
    var _this = this;
    if (state === void 0) {
      state = TriStateCheckbox_1.TriState.Full;
    }
    return nodeIds.reduce(function (p, c) {
      return _this.select(c, state, p);
    }, initialSelection !== null && initialSelection !== void 0 ? initialSelection : this.emptySelection());
  };
  TreeSelector.prototype._reversedPath = function (nodeId, context) {
    var p;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          p = this.parent(nodeId, context);
          _a.label = 1;
        case 1:
          if (!p) return [3 /*break*/, 3];
          return [4 /*yield*/, p];
        case 2:
          _a.sent();
          p = this.parent(p, context);
          return [3 /*break*/, 1];
        case 3:
          return [2 /*return*/];
      }
    });
  };

  TreeSelector.prototype._selectionBasedOnChildren = function (nodeId, selection, context) {
    var _a = __read(this.children(nodeId, context)),
      first = _a[0],
      other = _a.slice(1);
    var selFirstChild = first === undefined ? undefined : selection[first];
    return selFirstChild !== undefined ? R.any(function (child) {
      return selection[child] !== selFirstChild;
    }, other) ? TriStateCheckbox_1.TriState.Partial : selFirstChild : selection[nodeId];
  };
  TreeSelector.prototype._branchSelection = function (branchRoot, newState, context) {
    var _this = this;
    var reducer = function (acc, item) {
      return R.mergeRight(acc, _this._branchSelection(item, newState, context));
    };
    return R.reduce(reducer, R.objOf(branchRoot.toString(), newState), this.children(branchRoot, context).map(function (c) {
      return c.toString();
    }));
  };
  TreeSelector.prototype.select = function (nodeId, newState, initialSelection, context) {
    var _this = this;
    var sel0 = R.mergeRight(initialSelection, this._branchSelection(nodeId, newState, context));
    var newSel = function (accumSelection, item) {
      var sel = _this._selectionBasedOnChildren(item, accumSelection, context);
      return accumSelection[item] === sel ? R.reduced(accumSelection) : R.assoc(item.toString(), sel, accumSelection);
    };
    return R.reduce(newSel, sel0, __spreadArray([], __read(this._reversedPath(nodeId, context)), false));
  };
  TreeSelector.prototype.selectAllLeaves = function (predicate, newState, initialSelection, context) {
    var _this = this;
    var children = this.all(R.allPass([function (x) {
      return _this.isNotParent(x, context);
    }, function (x) {
      return predicate(x, context);
    }]), context);
    return R.reduce(function (acc, item) {
      return _this.select(item, newState, acc, context);
    }, initialSelection, __spreadArray([], __read(children), false).map(function (c) {
      return c.toString();
    }));
  };
  TreeSelector.prototype.toggle = function (nodeId, initialSelection, context) {
    var newSelection = initialSelection[nodeId] === TriStateCheckbox_1.TriState.Full ? TriStateCheckbox_1.TriState.Empty : TriStateCheckbox_1.TriState.Full;
    return this.select(nodeId, newSelection, initialSelection, context);
  };
  TreeSelector.prototype._describe = function (nodeId, selection, context, _inverse) {
    var _this = this;
    var selectionStatus = function (idArray) {
      var e_3, _a;
      var empty = 0;
      var partial = 0;
      var full = 0;
      try {
        for (var idArray_1 = __values(idArray), idArray_1_1 = idArray_1.next(); !idArray_1_1.done; idArray_1_1 = idArray_1.next()) {
          var id = idArray_1_1.value;
          switch (selection[id]) {
            case TriStateCheckbox_1.TriState.Empty:
              empty += 1;
              break;
            case TriStateCheckbox_1.TriState.Full:
              full += 1;
              break;
            default:
              partial += 1;
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (idArray_1_1 && !idArray_1_1.done && (_a = idArray_1.return)) _a.call(idArray_1);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
      return {
        empty: empty,
        partial: partial,
        full: full
      };
    };
    var flatten = function (array) {
      return array.length === 1 && Array.isArray(array[0]) ? array[0] : array;
    };
    var children = this.children(nodeId, context);
    var status = selectionStatus(children);
    var nodeName = this.parent(nodeId, context) == null ? "Everything" : this.name(nodeId, context);
    if (_inverse) {
      if (selection[nodeId] === TriStateCheckbox_1.TriState.Full) return ["not", nodeName];
      if (selection[nodeId] === TriStateCheckbox_1.TriState.Empty) return nodeName;
      if (status.full >= status.empty) {
        return flatten(children.filter(function (id) {
          return selection[id] !== TriStateCheckbox_1.TriState.Full;
        }).map(function (id) {
          return _this._describe(id, selection, context, true);
        }));
      } else {
        return [nodeName, "except", flatten(children.filter(function (id) {
          return selection[id] !== TriStateCheckbox_1.TriState.Empty;
        }).map(function (id) {
          return _this._describe(id, selection, context, false);
        }))];
      }
    } else {
      if (this.parent(nodeId, context) == null) {
        if (children.length === status.full) return nodeName;
        if (children.length === status.empty) return "Nothing";
      } else {
        if (selection[nodeId] === TriStateCheckbox_1.TriState.Empty) return ["not", nodeName];
        if (selection[nodeId] === TriStateCheckbox_1.TriState.Full) return nodeName;
      }
      if (status.full >= status.empty) {
        return [nodeName, "except", flatten(children.filter(function (id) {
          return selection[id] !== TriStateCheckbox_1.TriState.Full;
        }).map(function (id) {
          return _this._describe(id, selection, context, true);
        }))];
      } else {
        return flatten(children.filter(function (id) {
          return selection[id] !== TriStateCheckbox_1.TriState.Empty;
        }).map(function (id) {
          return _this._describe(id, selection, context, false);
        }));
      }
    }
  };
  TreeSelector.prototype.describe = function (selection, context) {
    return this._describe(this.rootId(context), selection, context, false);
  };
  TreeSelector.prototype.selectedIds = function (selection, context) {
    var _this = this;
    var ids = [];
    var inner = function (nodeId) {
      var value = selection[nodeId];
      switch (value) {
        case TriStateCheckbox_1.TriState.Empty:
          return;
        case TriStateCheckbox_1.TriState.Full:
          if (!R.isNil(_this.parent(nodeId, context))) {
            ids.push(nodeId);
          }
          return;
        default:
          _this.children(nodeId, context).forEach(inner);
      }
    };
    inner(this.rootId(context));
    return ids;
    var inner_old = function (nodeId) {
      if (!R.isNil(_this.parent(nodeId, context))) {
        console.log({
          parent: _this.parent(nodeId, context)
        });
        switch (selection[nodeId]) {
          case TriStateCheckbox_1.TriState.Empty:
            return;
          case TriStateCheckbox_1.TriState.Full:
            return;
          default:
            _this.children(nodeId, context).forEach(inner);
        }
      } else {
        switch (selection[nodeId]) {
          case TriStateCheckbox_1.TriState.Empty:
            return;
          case TriStateCheckbox_1.TriState.Full:
            return;
          default:
            _this.children(nodeId, context).forEach(inner);
        }
      }
    };
  };
  return TreeSelector;
}();
exports.TreeSelector = TreeSelector;